/**
 * TYPES
 */
import {_aggregates} from 'src/aggregates/index.d';
import {ICommand} from 'src/aggregates/index.d';


/**
 * EXPORTS
 */

/**
 * Commands names.
 */
export enum _names
{
    PREFERENCES_ADD_AUTO_MESSAGE = 'PREFERENCES_ADD_AUTO_MESSAGE',
    PREFERENCES_DISABLE_TOUR = 'PREFERENCES_DISABLE_TOUR',
    PREFERENCES_LOAD = 'PREFERENCES_LOAD',
    PREFERENCES_REMOVE_AUTO_MESSAGE = 'PREFERENCES_REMOVE_AUTO_MESSAGE',
    PREFERENCES_SET_CURRENT_AUTO_MESSAGE = 'PREFERENCES_SET_CURRENT_AUTO_MESSAGE',
    PREFERENCES_SET_EMAIL_PAGE_SIZE = 'PREFERENCES_SET_EMAIL_PAGE_SIZE',
    PREFERENCES_SET_FEEDBACK = 'PREFERENCES_SET_FEEDBACK',
    PREFERENCES_SET_TAG_COLOR = 'PREFERENCES_SET_TAG_COLOR',
    PREFERENCES_START = 'PREFERENCES_START',
    PREFERENCES_SWITCH_MUTE_NOTIFICATIONS = 'PREFERENCES_SWITCH_MUTE_NOTIFICATIONS',
    PREFERENCES_SWITCH_PAUSED = 'PREFERENCES_SWITCH_PAUSED',
    PREFERENCES_SWITCH_WALLET_REMINDER = 'PREFERENCES_SWITCH_WALLET_REMINDER',
}

/**
 * Commands interfaces.
 */
export interface IPreferencesAddAutoMessage extends ICommand
{
    _aggregate: _aggregates.PREFERENCES;
    _name: _names.PREFERENCES_ADD_AUTO_MESSAGE;
    message: string;
}

export interface IPreferencesDisableTour extends ICommand
{
    _aggregate: _aggregates.PREFERENCES;
    _name: _names.PREFERENCES_DISABLE_TOUR;
}

export interface IPreferencesLoad extends ICommand
{
    _aggregate: _aggregates.PREFERENCES;
    _name: _names.PREFERENCES_LOAD;
}

export interface IPreferencesRemoveAutoMessage extends ICommand
{
    _aggregate: _aggregates.PREFERENCES;
    _name: _names.PREFERENCES_ADD_AUTO_MESSAGE;
    message: number;
}

export interface IPreferencesSetCurrentAutoMessage extends ICommand
{
    _aggregate: _aggregates.PREFERENCES;
    _name: _names.PREFERENCES_SET_CURRENT_AUTO_MESSAGE;
    message: number;
}

export interface IPreferencesSetEmailPageSize extends ICommand
{
    _aggregate: _aggregates.PREFERENCES;
    _name: _names.PREFERENCES_SET_EMAIL_PAGE_SIZE;
    size: number;
}

export interface IPreferencesSetFeedback extends ICommand
{
    _aggregate: _aggregates.PREFERENCES;
    _name: _names.PREFERENCES_SET_FEEDBACK;
    feedback: number;
}

export interface IPreferencesSetTagColor extends ICommand
{
    _aggregate: _aggregates.PREFERENCES;
    _name: _names.PREFERENCES_SET_TAG_COLOR;
    color: string;
    tag: number;
}

export interface IPreferencesStart extends ICommand
{
    _aggregate: _aggregates.PREFERENCES;
    _name: _names.PREFERENCES_START;
}

export interface IPreferencesSwitchMuteNotifications extends ICommand
{
    _aggregate: _aggregates.PREFERENCES;
    _name: _names.PREFERENCES_SWITCH_MUTE_NOTIFICATIONS;
    muteNotifications: boolean;
}

export interface IPreferencesSwitchPaused extends ICommand
{
    _aggregate: _aggregates.PREFERENCES;
    _name: _names.PREFERENCES_SWITCH_PAUSED;
    paused: boolean;
}

export interface IPreferencesSwitchWalletReminder extends ICommand
{
    _aggregate: _aggregates.PREFERENCES;
    _name: _names.PREFERENCES_SWITCH_WALLET_REMINDER;
    walletReminder: boolean;
}
